const trimTrailingSlash = (url: string) => url.replace(/\/$/, '');

/** S3 桶直链：上传后即时预览、与预签名 PUT 目标一致 */
export const getMiniDramaUploadBaseUrl = () =>
    trimTrailingSlash(import.meta.env.VITE_MINI_DRAMA_ASSET_BASE_URL || '');

/** CDN 前缀：写入配置 / 客户端访问（dev&test: static.actqa.com，prod: static.story.fun） */
export const getMiniDramaCdnBaseUrl = () =>
    trimTrailingSlash(import.meta.env.VITE_MINI_DRAMA_CDN_BASE_URL || '');

const getKnownAssetBases = () =>
    [getMiniDramaCdnBaseUrl(), getMiniDramaUploadBaseUrl(), import.meta.env.VITE_WEB2_ASSETS || '']
        .map((base) => trimTrailingSlash(base))
        .filter(Boolean);

export const normalizeMiniDramaAssetPath = (path: string) => path.replace(/^\//, '');

/**
 * 从 path 或任意已知前缀的完整 URL 中提取对象 key
 * 例：admin/2026/06/24/xxx.jpg
 */
export const extractMiniDramaAssetPath = (url?: string) => {
    if (!url) return '';
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return normalizeMiniDramaAssetPath(url);
    }

    for (const base of getKnownAssetBases()) {
        if (url.startsWith(base)) {
            return url.slice(base.length).replace(/^\//, '');
        }
    }

    try {
        return new URL(url).pathname.replace(/^\//, '');
    } catch {
        return url;
    }
};

/** 拼 CDN 完整 URL，写入 banner 配置 */
export const resolveMiniDramaCdnUrl = (urlOrPath?: string) => {
    if (!urlOrPath) return '';

    if (urlOrPath.startsWith('http://') || urlOrPath.startsWith('https://')) {
        const cdnBase = getMiniDramaCdnBaseUrl();
        if (cdnBase && urlOrPath.startsWith(cdnBase)) {
            return urlOrPath;
        }
        const path = extractMiniDramaAssetPath(urlOrPath);
        return cdnBase ? `${cdnBase}/${path}` : urlOrPath;
    }

    const cdnBase = getMiniDramaCdnBaseUrl();
    if (!cdnBase) return normalizeMiniDramaAssetPath(urlOrPath);
    return `${cdnBase}/${normalizeMiniDramaAssetPath(urlOrPath)}`;
};

/** 后台编辑态展示：完整 URL 原样；相对 path 走 CDN */
export const resolveMiniDramaDisplayUrl = (urlOrPath?: string) => {
    if (!urlOrPath) return '';
    if (urlOrPath.startsWith('http://') || urlOrPath.startsWith('https://')) {
        return urlOrPath;
    }
    return resolveMiniDramaCdnUrl(urlOrPath);
};

/** 上传完成后拼 S3 直链（与预签名 url 去参一致，便于立刻反显） */
export const resolveMiniDramaUploadUrl = (path: string) => {
    const uploadBase = getMiniDramaUploadBaseUrl();
    const normalizedPath = normalizeMiniDramaAssetPath(path);
    if (!uploadBase) return normalizedPath;
    return `${uploadBase}/${normalizedPath}`;
};
